module.exports = __webpack_public_path__ + "img/10.069d2d75.jpg";